import React, { useCallback, useEffect } from 'react';
import { useVideoPlayerContext } from './VideoPlayerProvider';

export function WebRTCVideo() {
    const { webrtcRef, activeMediaRef, playing, onError, emitter } =
        useVideoPlayerContext();

    useEffect(() => {
        const video = activeMediaRef.current;
        if (!video) return;
        if (playing) {
            video.play().catch((err) => {
                if (err.name !== 'AbortError') {
                    console.error('Play failed:', err);
                }
            });
        } else {
            video.pause();
        }
    }, [playing, activeMediaRef]);

    const handleError = useCallback(
        (event: React.SyntheticEvent<HTMLVideoElement>) => {
            emitter.emit('error', event);
            onError(event);
        },
        [emitter, onError],
    );

    return (
        <video
            ref={webrtcRef}
            className="rounded-lg overflow-hidden object-contain w-full h-full"
            autoPlay
            playsInline
            crossOrigin="use-credentials"
            muted
            onDurationChange={() => emitter.emit('durationchange')}
            onEnded={() => emitter.emit('ended')}
            onError={handleError}
            onLoadedData={() => emitter.emit('loadeddata')}
            onLoadedMetadata={() => emitter.emit('loadedmetadata')}
            onPause={() => emitter.emit('pause')}
            onPlay={() => emitter.emit('play')}
            onPlaying={() => emitter.emit('playing')}
            onRateChange={() => emitter.emit('ratechange')}
            onSeeked={() => emitter.emit('seeked')}
            onSeeking={() => emitter.emit('seeking')}
            onTimeUpdate={() => emitter.emit('timeupdate')}
            onWaiting={() => emitter.emit('waiting')}
        />
    );
}
